module.exports = __webpack_public_path__ + "static/img/four.931e5a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/component/product_intro/four.svg
// module id = lclM
// module chunks = 30